export const PROPERTY_DETAILS_LAYER_LEGEND_SECTION_ID = 'property-details-layer-legend-section';
